import {
	hamburgerButton,
	overlay,
	fullBleedEls,
	projectTabs,
	stickyEls,
	heroEl,
	cards,
	videos,
	mqMobile,
	mqColumns,
	projectTitle,
	projectFilters,
	projectNavigationToggles,
	toggleContactDialogEls,
	footerContactButton,
	floatingMenuToggle,
	projectsLayout,
	homeContactButtons,
	sortTableButtons,
	body,
} from './lib/elements.js'
import {
	toggleMenu,
	handleMenuClick,
	handleTabsClick,
	handleTabsKeyboard,
	makeSticky,
	heroObserver,
	playPauseVideo,
	adjustHeight,
	setStickyOffset,
	manageProjectFilters,
	toggleProjectNavigation,
	handleContactDialog,
	moveFooterContactButton,
	toggleFloatingMenu,
	manageProjectsLayout,
	toggleHomeContactMenu,
	handleProjectSorting,
	moveBlockTitles,
} from './lib/handlers.js'
import {
	handleFirstTab,
	disableAnimationOnResize,
	scrollbarFix,
	handleCardClick,
} from './lib/lib.js'

// Hamburger toggle
hamburgerButton.addEventListener('click', toggleMenu)
document.addEventListener('keyup', toggleMenu)

// Remove :focus outline unless user is using the keyboard to navigate
window.addEventListener('keydown', handleFirstTab)

// Disable animations on window resize to improve performace
window.addEventListener('resize', disableAnimationOnResize)

// Handle main menu clicks
document.addEventListener('click', handleMenuClick)
document.addEventListener('keyup', handleMenuClick)

// Remove horizontal scroll when using full bleed utility
if (fullBleedEls && !body.classList.contains('home')) {
	scrollbarFix()
}

// Handle project panel Toggle
if (projectTabs) {
	projectTabs.forEach((item) => {
		// Handle tabs for mouse users
		item.addEventListener('click', handleTabsClick)
		// Handle tabs for keyboard users
		item.addEventListener('keydown', handleTabsKeyboard)
	})
}

// Make items sticky if enough space
if (stickyEls) {
	stickyEls.forEach((item) => {
		makeSticky(item)
	})
}

if (heroEl) {
	heroObserver.observe(heroEl)
	if (mqMobile.matches) {
		adjustHeight(heroEl)
	}
}

// Handle card clicks
cards.forEach((item) => item.addEventListener('click', handleCardClick))

// Handle video clicks
if (videos) {
	videos.forEach((item) => {
		item.addEventListener('click', playPauseVideo)
	})
}

// Get project title to calculate sticky offset
if (projectTitle) {
	setStickyOffset()
}

// Manage project filters
if (projectFilters) {
	projectFilters.forEach((item) => {
		item.addEventListener('click', manageProjectFilters)
	})
}
// Trigger project filters on load from URL
manageProjectFilters()

// Manage projects layout changes
if (projectsLayout) {
	projectsLayout.forEach((item) => {
		item.addEventListener('click', manageProjectsLayout)
	})
}

if (projectNavigationToggles) {
	projectNavigationToggles.forEach((item) => {
		item.addEventListener('click', toggleProjectNavigation)
	})
}

// Listen to contact dialog toggle events
if (toggleContactDialogEls) {
	toggleContactDialogEls.forEach((item) => {
		item.addEventListener('click', handleContactDialog)
	})
}

// if (footerContactButton) {
// 	moveFooterContactButton()
// }

if (floatingMenuToggle) {
	floatingMenuToggle.addEventListener('click', toggleFloatingMenu)
	document.addEventListener('keyup', toggleFloatingMenu)
}

if (homeContactButtons) {
	homeContactButtons.forEach((item) => {
		item.addEventListener('click', toggleHomeContactMenu)
	})
	document.addEventListener('keyup', toggleHomeContactMenu)
}

if (sortTableButtons) {
	sortTableButtons.forEach((item) => {
		item.addEventListener('click', handleProjectSorting)
	})
}

// Move Media Text Block titles on mobile
moveBlockTitles(mqColumns)
mqColumns.addListener(moveBlockTitles)
